import React from "react";
import {theme , Tooltip } from "antd";
import {  EditOutlined,  CarOutlined,  PlusCircleFilled,} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { URL_SALE } from "../../constants/urls";
import { DELETE } from "../../frameworks/HttpClient";
import TSTable from "../../common/TSTable";
import { useState } from "react";
import AddSaleListModal from "./AddSaleListModal";
import { PRODUCT_TYPE } from "../../constants/string";
import { PATH } from "../../routes/CustomRoutes";
import { dateToHumanString, dateToString, formatComma } from "../../frameworks/Util";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import { PRINT_COLOR } from "../../constants/color";
import StockConcentrateSellModal from "./StockConcentrateSellModal";
import * as _ from "lodash";

const SaleList = React.forwardRef((props, ref) => {
  const { isDone } = props;
  const {
    token: { colorWarning ,colorSuccess ,colorPrimary },
  } = theme.useToken();
  const [errorMessage, setErrorMessage] = useState(null);
  const tableRef = React.useRef(null);
  const [openAddSaleListModal , setOpenAddSaleList] = React.useState(null);
  const [openStockModal , setOpenStockModal] = React.useState(null);
  const [target , setTarget ] = React.useState(null);

  React.useImperativeHandle(ref, () => ({
    fetchTable : () => refreshData()
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      await tableRef.current.fetchWithoutResetPage();
    }
  };

  const handleEdit = (record) => {
    setTarget(record);
    setOpenAddSaleList(true);
  };
  
  const handleDelete = async (id) => {
    setErrorMessage(null);
    try {
      await DELETE(`${URL_SALE.SALE_ORDER}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessage(error.errorMessage);
    }
  };

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width: 200,
      key: 'Action',
      hidden: isDone,
      render: (value, original) => (
        <div style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
          <Tooltip triger='hover' title={"รายการแจ้งผลิต"}>
            <ColorButton 
              override={colorSuccess}
              style={{ margin: 5 }}
              type='primary'
              icon={<FontAwesomeIcon icon={faDatabase} />}
              onClick={() => window.open(`${PATH.PRODUCE_ORDER}/${PRODUCT_TYPE.CONCENTRATE_LATEX}/${original.id}`)} 
            />
          </Tooltip>
          <Tooltip triger='hover' title={"รายการส่งน้ำยางข้น"}>
            <ColorButton 
              style={{ margin: 5 }}
              override={colorPrimary}
              type='primary'
              icon={<CarOutlined />}
              onClick={() => window.open(`${PATH.DELIVERY_ORDER}/${PRODUCT_TYPE.CONCENTRATE_LATEX}/${original.id}`)} 
            />
          </Tooltip>
          {!_.get(original, 'has_loaded_tank', true) && (
            <CustomDeleteConfirmButton
                onOk={ async() => {
                await handleDelete(original.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
          )}
          <Tooltip triger='hover' title={"แก้ไขรายการขาย"}>
            <ColorButton 
              override={colorWarning}
              style={{ margin: 5 }}
              type='primary'
              icon={<EditOutlined />}
              onClick={() => handleEdit(original)} 
            />
          </Tooltip>
        </div>
      )
    },
    {
      title: 'วันที่',
      dataIndex: 'order_date',
      key: 'order_date',
      render: (value) => dateToHumanString(value),
    },
    {
      title: 'Contract No.',
      dataIndex: 'order_no',
      key: 'order_no',
      searcher : true,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'buyer_name',
      key: 'buyer_name',
      searcher : true,  
    },
    {
      title: 'สินค้าที่ต้องการ',
      dataIndex: 'product_name',
      key: 'product_name',
    },
    {
      title: 'Shipment',
      dataIndex: 'shipment',
      key: 'shipment',
    },
    {
      title: 'ปริมาณสั่งซื้อ (kg)',
      dataIndex: 'require_weight',
      key: 'require_weight',
      render: (value) => <center>{formatComma(value)}</center>
    },
    {
      title: 'ปริมาณส่งออก (kg)',
      dataIndex: 'delivery_weight',
      key: 'delivery_weight',
      render: (value) => <center>{formatComma(value)}</center>
    },
  ];

  return (
    <div>
      {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
      <ColorButton
        type="primary"
        override={colorSuccess}
        icon={<PlusCircleFilled />}
        style={{ marginBottom: 10, float: "right" }}
        onClick={() => setOpenAddSaleList(true)}
      >
        เพิ่มรายการขายน้ำยางข้น
      </ColorButton>
      <ColorButton
        type="primary"
        override={PRINT_COLOR}
        icon={ <FontAwesomeIcon icon={faDatabase} />}
        style={{ marginBottom: 10, float: "right", marginRight : 8}}
        onClick={() => setOpenStockModal(true)}
      >
        สต๊อกน้ำยางข้น
      </ColorButton>
      <TSTable
        columns={columns}
        size={'small'}
        url={URL_SALE.SALE_ORDER}
        ref={tableRef} 
      />
      
      <StockConcentrateSellModal
        open ={openStockModal}
        onClose = {() => {
          setOpenStockModal(false);
          setTarget(null);
        }}
        onUpdate = {() => {
          setOpenStockModal(false);
          setTarget(false);
          refreshData();
        }}
      />

      <AddSaleListModal
        open ={openAddSaleListModal}
        onClose = {() => {
          setOpenAddSaleList(false);
          setTarget(null);
        }}
        onUpdate = {() => {
          setOpenAddSaleList(false);
          setTarget(false);
          refreshData();
        }}
        target={target}
      />
    </div>
  );
});

export default SaleList;
